import { useRouter } from "next/router";
function useCheckLiveInteractionContainer() {
  var _useRouter = useRouter(),
    pathname = _useRouter.pathname;
  if (pathname.includes("/live-interaction")) {
    return true;
  }
  return false;
}
export default useCheckLiveInteractionContainer;